/* 🤖 this file was generated by svg-to-ts */
export const matIconEMobiledata: {
  name: 'e-mobiledata';
  data: string;
} = {
  name: 'e-mobiledata',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z"/></svg>`
};
